var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#00DF80",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1254_19985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 31,
    height: 30
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.875,
    y: 5.375,
    width: 29.25,
    height: 29.25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1254_19985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7938 25.6063L26.3859 17.0141L24.6797 15.3078L17.7938 22.1938L14.3203 18.7203L12.6141 20.4266L17.7938 25.6063ZM19.5 32.1875C17.8141 32.1875 16.2297 31.8674 14.7469 31.2271C13.2641 30.5877 11.9742 29.7195 10.8773 28.6227C9.78047 27.5258 8.91231 26.2359 8.27288 24.7531C7.63263 23.2703 7.3125 21.6859 7.3125 20C7.3125 18.3141 7.63263 16.7297 8.27288 15.2469C8.91231 13.7641 9.78047 12.4742 10.8773 11.3773C11.9742 10.2805 13.2641 9.41191 14.7469 8.77166C16.2297 8.13222 17.8141 7.8125 19.5 7.8125C21.1859 7.8125 22.7703 8.13222 24.2531 8.77166C25.7359 9.41191 27.0258 10.2805 28.1227 11.3773C29.2195 12.4742 30.0877 13.7641 30.7271 15.2469C31.3674 16.7297 31.6875 18.3141 31.6875 20C31.6875 21.6859 31.3674 23.2703 30.7271 24.7531C30.0877 26.2359 29.2195 27.5258 28.1227 28.6227C27.0258 29.7195 25.7359 30.5877 24.2531 31.2271C22.7703 31.8674 21.1859 32.1875 19.5 32.1875Z",
    fill: "#00DF80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMarkIcon);
export default __webpack_public_path__ + "static/media/TickMarkIcon.fcbc494a552073b0afa7d05d2e3c6718.svg";
export { ForwardRef as ReactComponent };